
<div *ngIf="data.headerEnabled" class="promo-top w-100 h-auto text-center theme-container"
    [style.backgroundImage]="'url(' + serverPath2 + data.headerLogoSrc + ')'"
    onerror="this.src='assets/images/notification-back.jpg';">
    <h4 [style.color]="data.headerBannerTextColour" class="font-weight-normal text-uppercase text-white m-0">
        {{data.headerNotificationContent}}</h4>
</div>

<div *ngIf="display">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="top-bar">
        <div fxLayout="row" fxLayoutGap="10px" class="top-links">
            <span (click)="openPages()">Wishlist</span> | &#160;
            <span (click)="openPage()">Your Orders</span>
        </div>
        <div class="delivery-text">{{data.headerNotificationContent}}</div>
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" class="lang-currency">
            <span>Call Us:+ {{data.storePhoneNumber}}</span> <span *ngIf="languageSelection==1">| &#160;</span>
            <div *ngIf="languageSelection==1">
                <calsoft-language style="color: black"></calsoft-language>
            </div>
        </div>
    </div>
    <mat-toolbar [class.active]="showFixedHeader" style="background-color: white;border-bottom: 1px solid #eee;" fxHide
        fxShow.gt-md fxLayout="row" fxLayoutAlign="space-around center">

        <mat-toolbar-row class="theme-container" style="height: 100%; background-color: white;padding: 6px 16px;"
            fxLayoutAlign="space-around center">
            <section fxFlex="25">
                <div *ngIf="data.disableSearchInHeader==0" class="search-bar" fxHide fxShow.gt-sm fxShow.gt-sm
                    fxLayout="row" fxLayoutAlign="start center" fxFlex fxFlex.gt-sm="300px">
                    <calsoft-search [scroll]="false" [design]="'2'"></calsoft-search>
                </div>
            </section>

            <section fxFlex="50">
                <calsoft-logo [sitename]="data.siteName" [type]="'light'"></calsoft-logo>
            </section>

           
            <section fxFlex="25" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">
                <!-- <div *ngIf="languageSelection==1">
                    <calsoft-language style="color: black"></calsoft-language>
                </div> -->

                    <button mat-button (click)="openPages()">
                        <mat-icon class="loginicon2">favorite_border</mat-icon>
                        <span class="logicon">&#160;Wishlist</span>
                    </button>
                
                <div *ngIf="data.disableLoginHeader==0">
                    <button *ngIf="!userLoggedIn" (click)="SignIn('login')"  mat-button>
                        <div style="display:flex;" >
                            <mat-icon class="loginicon">person</mat-icon>
                            <span class="logicon">&#160;Login</span>
                        </div>
                    </button>
                </div>
                <div *ngIf="data.disableLoginHeader==0">
                    <calsoft-HeaderUserProfileDropdown [data]="data" class="headerUser" *ngIf="userLoggedIn" [design]="'2'">
                    </calsoft-HeaderUserProfileDropdown>
                </div>

                <calsoft-cart-icon [data]="data" [design]="'2'"></calsoft-cart-icon>
            </section>

        </mat-toolbar-row>

    </mat-toolbar>
    <!-- <div [ngClass]="{'sticky': isSticky}" class="app-toolbar primary" *ngIf="data.headerEnabled==1">
        <mat-toolbar  fxHide fxShow.gt-md fxLayout="row" fxLayoutAlign="center center"
            style="margin-bottom: 0px;height: -webkit-fill-available;background-color: white;">

            <mat-toolbar-row class="theme-container" fxLayoutAlign="center center">
                <calsoft-Menu [color]="false" [data]="data" [type]="'two'" [categoryArray]="item"></calsoft-Menu>
            </mat-toolbar-row>
        </mat-toolbar>
    </div> -->

    <div *ngIf="data.headerEnabled==0">
        <mat-toolbar fxHide fxShow.gt-md fxLayout="row" fxLayoutAlign="center center"
            style="margin-top: 0px; margin-bottom: 0px;height: -webkit-fill-available;background-color: white;">
            <mat-toolbar-row class="theme-container" fxLayoutAlign="center center">
                <calsoft-Menu [color]="false" [data]="data" [type]="'two'" [categoryArray]="item"></calsoft-Menu>
            </mat-toolbar-row>
        </mat-toolbar>
    </div>

</div>

<div *ngIf="!display">

    <div *ngIf="mobileHeaderType==1">
        <calsoft-mobile-header [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header>
    </div>

    <div *ngIf="mobileHeaderType==0">
        <calsoft-mobile-header-new [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header-new>
    </div>

    <div *ngIf="mobileHeaderType==2">
        <calsoft-mobile-header3 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header3>
    </div>

    <div *ngIf="mobileHeaderType==3">
        <calsoft-mobile-header4 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header4>
    </div>

    <div *ngIf="mobileHeaderType==4">
        <calsoft-mobile-header5 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header5>
    </div>

    <div *ngIf="mobileHeaderType==5">
        <calsoft-mobile-header6 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header6>
    </div>
    <div *ngIf="mobileHeaderType==6">   
        <calsoft-mobile-header7 [item]="item" [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header7>
    </div>
    <div *ngIf="mobileHeaderType==7">

        <calsoft-mobile-header8 [item]="item" [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header8>
    </div>
    <div *ngIf="mobileHeaderType==8">
        <calsoft-mobile-header9 [item]="item" [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header9>
    </div>
        <div *ngIf="mobileHeaderType==10">
        <calsoft-mobile-header11 [item]="item" [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header11>
    </div>
</div>